// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jm-0";
export var buttonContainer = "_jm-3";
export var cancelButton = "_jm-4";
export var headerSection = "_jm-6";
export var headerTitle = "_jm-9";
export var messageSideLeft = "_jm-1";
export var messageSideRight = "_jm-2";
export var orderNumberContainer = "_jm-7";
export var orderNumberLabel = "_jm-8";
export var submitButton = "_jm-5";